/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SimpleDataRequestResource } from './SimpleDataRequestResource';
import {
    SimpleDataRequestResourceFromJSON,
    SimpleDataRequestResourceFromJSONTyped,
    SimpleDataRequestResourceToJSON,
    SimpleDataRequestResourceToJSONTyped,
} from './SimpleDataRequestResource';

/**
 * 
 * @export
 * @interface LatestLogDataRequest
 */
export interface LatestLogDataRequest {
    /**
     * 
     * @type {string}
     * @memberof LatestLogDataRequest
     */
    locale: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof LatestLogDataRequest
     */
    generatorStatus?: Array<string>;
    /**
     * 
     * @type {Array<SimpleDataRequestResource>}
     * @memberof LatestLogDataRequest
     */
    resources: Array<SimpleDataRequestResource>;
}

/**
 * Check if a given object implements the LatestLogDataRequest interface.
 */
export function instanceOfLatestLogDataRequest(value: object): value is LatestLogDataRequest {
    if (!('locale' in value) || value['locale'] === undefined) return false;
    if (!('resources' in value) || value['resources'] === undefined) return false;
    return true;
}

export function LatestLogDataRequestFromJSON(json: any): LatestLogDataRequest {
    return LatestLogDataRequestFromJSONTyped(json, false);
}

export function LatestLogDataRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): LatestLogDataRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'locale': json['locale'],
        'generatorStatus': json['generatorStatus'] == null ? undefined : json['generatorStatus'],
        'resources': ((json['resources'] as Array<any>).map(SimpleDataRequestResourceFromJSON)),
    };
}

export function LatestLogDataRequestToJSON(json: any): LatestLogDataRequest {
    return LatestLogDataRequestToJSONTyped(json, false);
}

export function LatestLogDataRequestToJSONTyped(value?: LatestLogDataRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'locale': value['locale'],
        'generatorStatus': value['generatorStatus'],
        'resources': ((value['resources'] as Array<any>).map(SimpleDataRequestResourceToJSON)),
    };
}

